<template>
  <div id="mainContainer" ref="mainContainer" class="slideshow-container" :style="getMainStyle" @contextmenu.prevent="userRightClick">
    <div id="tttSlideshow" ref="tttSlideshow" v-touch:swipe="swipeHandler" class="ttt-slideshow" tabindex="0" @keyup="keyboardPressed">
      <div id="slideshowMask" ref="slideshowMask" class="slideshow-mask" :style="getMaskStyle">
        <div id="slideshowItemsHolder" ref="slideshowItemsHolder" class="slideshow-contents" :style="getSlideshowWidth">
          <div v-for="(item, index) in slideshowArray" :key="`slideshow-items${index}`" tabindex="0">
            <promo-slider-item
              :id="index"
              :ref="`ssitem${index}`"
              :alt="item.title"
              :img-u-r-l="item.imgURL"
              :thumb-u-r-l="item.thumbURL"
              :bgPosition="item.bgPosition"
              :title="item.title"
              :content="item.content"
              :use-backround-image="useBackroundImage"
              :animateContent="animateContent"
              @overlayClicked="overlayClicked"
            />
          </div>
        </div>
      </div>

      <div v-if="showNavButtons" id="carouselNav" ref="carouselNav" class="carousel-nav" :style="getNavContainerStyle">
        <div ref="leftBtn" class="left-button" :style="getNavStyles('left')" @click.prevent.stop="navButtonClicked(CAROUSEL_DIRECTION.RIGHT)">
          <img :src="navIconUrl" alt="left" :style="navButtonsSize" class="arrow-button lazyload">
        </div>
        <div ref="rightBtn" class="right-button" :style="getNavStyles('right')" @click.prevent.stop="navButtonClicked(CAROUSEL_DIRECTION.LEFT)">
          <img :src="navIconUrl" alt="right" :style="navButtonsSize" class="arrow-button btn-right lazyload">
        </div>
      </div>

      <div v-if="showSlideshowControls" id="ssControls" ref="ssControls" class="slideshow-controls" :style="getMainWidth">
        <div class="controls-btn" @click.prevent.stop="toggleThumbnails">
          <img :src="require('../../assets/img/src/icons/slideshow/Grid.svg')" alt="Thumbnails" class="ss-controls-img lazyload">
        </div>
        <div class="controls-btn" @click.prevent.stop="toggleSlideshow()">
          <img v-show="!slideshowPlaying" :src="require('../../assets/img/src/icons/slideshow/Circle-Play.svg')" alt="Play Slideshow" class="ss-controls-img playpause lazyload">
          <img v-show="slideshowPlaying" :src="require('../../assets/img/src/icons/slideshow/Circle-Pause.svg')" alt="Pause Slideshow" class="ss-controls-img playpause lazyload">
        </div>
        <div class="controls-btn">
          {{ getSlideshowCount }}
        </div>
        <div class="controls-btn ss-title">
          {{ getSlideshowImageDescription }}
        </div>
        <!-- <div class="controls-btn" @click="openImagePopup" @dblclick="exitFullscreen"><img :data-src="require('../../assets/img/src/icons/slideshow/External.svg')" alt="Open Image" class="ss-controls-img" /></div> -->
        <div class="controls-btn" @click.prevent.stop="toggleFullScreen">
          <img :src="require('../../assets/img/src/icons/slideshow/Maximise.svg')" alt="Maximise full screen" class="ss-controls-img lazyload">
        </div>
      </div>

      <div v-if="showSlideshowControls" id="thumbsMask" ref="thumbsMask" class="thumbs-mask" :style="thumbContainerMaskStyles">
        <div id="thumbsContainer" ref="thumbsContainer" class="slideshow-thumbnails-container" :style="thumbContainerStyles">
          <div v-for="(page, index) in thumbnailPages" :key="`slideshow-page${index}`">
            <div class="slideshow-thumbnails-page" :style="thumbPageStyles">
              <div v-for="(img, index) in thumbnailPages[index].items"
                   :key="`slideshow-thumb${index}`"
                   class="thumb-img-holder"
                   :style="thumbnailSize"
                   @click.prevent.stop="thumbnailClicked(img.id)"
              >
                <img
                  :id="img.id"
                  :key="`ssimg${img.id}`"
                  :ref="`thumbImage${index}`"
                  :data-src="img.thumbURL"
                  :alt="img.title"
                  class="thumb-img lazyload"
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="showThumbnailsDotsMenu && thumbnailPages.length > 1" id="dotsmenu" ref="dotsmenu" class="dots-menu">
          <dots-menu ref="dots" :items="thumbnailPagesList" :select-id="thumbnailPageID" @onclick="slideToThumbnailPage" />
        </div> -->
      </div>

      <div v-if="fullscreen || fullscreenFake" ref="slideshowClose" class="slideshow-close" @click.prevent.stop="exitFullscreen">
        <img :src="require('../../assets/img/src/icons/slideshow/close.png')" alt="exit full screen" class="slideshow-close-img lazyload">
      </div>

      <div v-if="showFullScreenIcon && !fullscreen && !fullscreenFake" class="slideshow-full-screen-btn" @click.prevent.stop="toggleFullScreen">
        <img :src="fullScreenIcon" alt="View full screen" class="slideshow-full-screen-btn-img lazyload">
      </div>

      <div v-if="showCountOverlay" class="slideshow-count-overlay">
        {{ getSlideshowCount }}
      </div>

      <div v-if="!slideshowLoaded" class="loading-text" :style="loadingTextStyle">
        {{ loadingDescription }}
      </div>

      <!-- <div class="tracetxt" v-html="tracetext" /> -->
    </div>

    <!-- <div v-if="showDotsNavigation" class="dots-nav">
      <dots-menu ref="navDotsMenu" class="dots-nav-menu" :items="slideshowImages" :select-id="navDotIndex" @onclick="navDotClicked" />
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import Bus from '../../events/bus';
import { CAROUSEL_DIRECTION } from '../../constants/constants.js';
// import DotsMenu from './DotsMenu.vue';
import PromoSliderItem from './PromoSliderItem.vue';

export default {
  name: 'PromoSlider',
  components: {
    // DotsMenu,
    PromoSliderItem,
  },
  props: {
    slideshowData: { type: Array, required: true, default: () => [] },
    itemsInView: { type: Number, default: 1 },
    imageIndex: { type: [Number, String], default: 0 },
    easing: { type: [Object, String], default: () => Power4.easeOut },
    tweenSpeed: { type: Number, default: 1 },
    thumbsTweenTime: { type: Number, default: 0.3 },
    slideshowAutoPlayDelayTime: { type: Number, default: 3 },
    autoPlay: { type: Boolean, default: false },
    bleedEdges: { type: Boolean, default: false },
    animateContent: { type: Boolean, default: false },

    navIconUrl: { type: String, default: require('../../assets/img/src/icons/curved-arrow-left-circle.svg') },
    navIconSize: { type: String, default: '30px' },
    navIconPosition: { type: String, default: '20px' },
    toggleNavVisibility: { type: Boolean, default: false },
    hideNav: { type: Boolean, default: false },

    slideshowControls: { type: Boolean, default: false },
    slideshowImageWidth: { type: String, default: '800px' },
    slideshowImageHeight: { type: String, default: '533px' },
    slideshowThumbWidth: { type: String, default: '150px' },
    slideshowThumbHeight: { type: String, default: '110px' },

    showCountOverlay: { type: Boolean, default: false },
    showFullScreenIcon: { type: Boolean, default: false },
    fullScreenIcon: { type: String, default: require('../../assets/img/src/icons/slideshow/Fullscreen-icon.svg') },

    containHeight: { type: Boolean, default: false },
    useBackroundImage: { type: Boolean, default: false },
    showDotsNavigation: { type: Boolean, default: false },
    renderFullScreen: { type: Boolean, default: false },
  },
  data() {
    return {
      CAROUSEL_DIRECTION,
      tracetext: '',
      originalItems: [],
      slideshowItems: [],
      carouselItems: [],
      positions: [],
      slideshowImages: [],

      numberOfItems: 0,
      posIndex: 1,
      visibleIndex: 1,
      itemWidth: 0,
      repeatStartPosition: 0,
      repeatEndPosition: 0,
      topMargin: 0,

      interaction: false,
      fullscreen: false,
      fullscreenFake: false,
      slideshowPlaying: false,
      showThumbnails: false,
      showThumbnailsDotsMenu: false,
      appInitialised: false,

      visibleItems: this.itemsInView,
      hideNavigation: this.hideNav,
      autoPlayDelayTime: this.slideshowAutoPlayDelayTime,

      ssImgWidth: this.slideshowImageWidth,
      ssImgHeight: this.slideshowImageHeight,
      ssdivHeight: this.slideshowImageHeight,
      ssThumbWidth: this.slideshowThumbWidth,
      ssThumbHeight: this.slideshowThumbHeight,

      thumbnailPages: [{ id: 0 }],
      thumbnailPageID: 0,
      thumbPagesWidth: this.slideshowImageWidth,
      thumbsXnum: 5,
      thumbsYnum: 4,

      imagesObserver: null,
      allImagesLoaded: false,
      loadedImages: new Set(),
      loadingText: 'Loading............',
      imageErrors: 0,

      navDotIndex: 0,
      tweenTime: 1,

      topPosition: '0px',
      leftPosition: '0px',
      viewWidth: 0,
      viewheight: 0,
      resizeDone: false,
      onResizeDebouncedTimeout: null,
      onResetDebouncedTimeout: null,
    };
  },
  computed: {
    slideshowArray() {
      return this.slideshowItems;
    },
    getMainStyle() {
      const container_width = this.visibleItems * this.itemWidth;
      return {
        width: this.appInitialised ? this.convertNumberToPixel(container_width) : this.slideshowImageWidth,
        height: this.appInitialised ? null : this.convertNumberToPixel(parseInt(this.slideshowImageHeight) + 50),
        marginTop: this.fullscreenFake ? '0px' : this.convertNumberToPixel(this.topMargin),
        zIndex: this.fullscreenFake ? '99999' : '1',
        position: this.fullscreenFake ? 'fixed' : 'relative',
        top: this.topPosition,
        left: this.leftPosition,
      };
    },
    getMainWidth() {
      const container_width = this.visibleItems * this.itemWidth;
      return {
        width: this.appInitialised ? this.convertNumberToPixel(container_width) : this.slideshowImageWidth,
      };
    },
    getSlideshowWidth() {
      const container_width = this.numberOfItems * this.itemWidth;
      return {
        width: this.convertNumberToPixel(container_width),
      };
    },
    getNavContainerStyle() {
      const container_width = this.visibleItems * this.itemWidth;
      const middle = (Math.floor(parseInt(this.ssdivHeight)) / 2);
      return {
        width: this.convertNumberToPixel(container_width),
        top: '47%', // this.convertNumberToPixel(middle),
      };
    },
    showNavButtons() {
      return !this.hideNavigation;
    },
    getMaskStyle() {
      return {
        overflow: this.bleedEdges ? 'visible' : 'hidden',
      };
    },
    navButtonsSize() {
      return {
        width: this.navIconSize,
        height: this.navIconSize,
      };
    },
    showSlideshowControls() {
      return this.slideshowControls;
    },
    getSlideshowImageDescription() {
      if (this.slideshowItems.length > 1) {
        let title = this.slideshowItems[this.posIndex].title;
        title !== undefined ? title = title.replace('<br/>', ' ') : title = 'Image Gallery';
        return title;
      }

      return 'Image Gallery';
    },
    getSlideshowCount() {
      let realid = Math.abs(this.numberOfItems - this.posIndex);
      const r = Math.floor(realid / this.numberOfItems);
      realid = this.posIndex > this.numberOfItems ? realid - (r * this.numberOfItems) : this.posIndex;
      realid = realid <= 0 ? this.numberOfItems : realid;
      this.visibleIndex = realid;
      return `${this.visibleIndex} / ${this.numberOfItems}`;
    },
    thumbContainerMaskStyles() {
      return {
        position: 'absolute',
        width: this.ssImgWidth,
        height: this.ssImgHeight === 'auto' ? this.ssdivHeight : this.ssImgHeight,
      };
    },
    thumbnailPagesList() {
      return this.thumbnailPages;
    },
    thumbContainerStyles() {
      return {
        position: 'absolute',
        width: this.convertNumberToPixel(this.thumbPagesWidth),
        height: this.ssImgHeight === 'auto' ? this.ssdivHeight : this.ssImgHeight,
      };
    },
    thumbPageStyles() {
      return {
        position: 'relative',
        width: this.ssImgWidth,
        height: this.ssImgHeight === 'auto' ? this.ssdivHeight : this.ssImgHeight,
        gridTemplateColumns: `repeat(${this.thumbsXnum}, auto)`,
        gridTemplateRows: `repeat(${this.thumbsYnum}, auto)`,
      };
    },
    thumbnailSize() {
      return {
        width: this.ssThumbWidth,
        height: this.ssThumbHeight,
      };
    },
    loadingDescription() {
      return this.loadingText;
    },
    slideshowLoaded() {
      return this.allImagesLoaded;
    },
    loadingTextStyle() {
      return {
        width: this.ssImgWidth,
      };
    },
    fullScreenAvailable() {
      if (document.exitFullscreen) {
        return true;
      }
      if (document.mozCancelFullScreen) {
        return true;
      }
      if (document.webkitExitFullscreen) {
        return true;
      }
      if (document.msExitFullscreen) {
        return true;
      }

      return false;
    },
    getComponentInView() {
      return this.$refs[`ssitem${this.posIndex}`][0];
    },
  },
  watch: {
    toggleNavVisibility: {
      handler(val) {
        if (val) {
          window.addEventListener('mousemove', this.mouseIsMoving);
        }
        else {
          window.removeEventListener('mousemove', this.mouseIsMoving);
        }
      },
      immediate: true,
      deep: true,
    },
    renderFullScreen(n) {
      if (n) {
        this.loadFullScreenSlideshow();
      }
    },
    slideshowData: {
      handler(val) {
        this.setupAppData();
      },
      immediate: false,
      deep: true,
    },
    imageIndex: {
      handler(index) {
        this.posIndex = index;
        this.slideTo(index, 0, 0);
      },
      immediate: false,
      deep: true,
    },
    hideNav: {
      handler(val) {
        this.hideNavigation = val;
      },
      immediate: true,
      deep: true,
    },
    posIndex(n) {
      this.navDotIndex = n - 1;

      if (this.navDotIndex >= this.numberOfItems) {
        this.navDotIndex = 0;
      }

      if (this.navDotIndex < 0) {
        this.navDotIndex = this.numberOfItems - 1;
      }
    },
  },
  mounted() {
    // console.log('-----SLIDESHOW MOUNTED --------', this);

    // console.log('-----SLIDESHOW slideshowData --------', this.slideshowData);

    // this.setupConsole();

    TweenMax.defaultOverwrite = 'all';

    this.setupAppData();
  },
  destroyed() {
    // console.log('-----SLIDESHOW DESTROYED --------');
    this.removeListeners();
    TweenMax.killTweensOf(this);
  },
  methods: {

    // ------------------- INTI SLIDESHOW  ----------------------//

    setupAppData() {
      TweenMax.set(this.$refs.slideshowItemsHolder, { css: { left: 0 } });
      TweenMax.set(this.$refs.tttSlideshow, { alpha: 0 });

      this.visibleItems = this.itemsInView;
      this.hideNavigation = this.hideNav;
      this.autoPlayDelayTime = this.slideshowAutoPlayDelayTime;
      this.ssImgWidth = this.slideshowImageWidth;
      this.ssImgHeight = this.slideshowImageHeight;
      this.ssdivHeight = this.slideshowImageHeight;
      this.ssThumbWidth = this.slideshowThumbWidth;
      this.ssThumbHeight = this.slideshowThumbHeight;

      this.originalItems = this.slideshowData;
      this.slideshowData.length > 1 ? this.initSlideshowData() : null;

      this.autoPlay ? TweenMax.delayedCall(5, this.toggleSlideshow) : null;
    },

    initSlideshowData() {
      // console.log('init slideshow ', this.originalItems )
      this.numberOfItems = this.originalItems.length;

      this.slideshowItems = null;
      const tempArray = this.originalItems.map((element) => {
        const {
          imgURL, thumbURL, title, image, bgPosition, content,
        } = element;
        return {
          imgURL, thumbURL, title, image, bgPosition, content,
        };
      });

      const firstItem = this.originalItems[0];
      const lastItem = this.originalItems[this.numberOfItems - 1];
      tempArray.unshift(lastItem);
      tempArray.push(firstItem);

      this.slideshowItems = tempArray;

      this.$nextTick(() => {
        if (this.$refs.slideshowItemsHolder) {
          this.carouselItems = Array.from(this.$refs.slideshowItemsHolder.children);
        }
        if (!this.allImagesLoaded) {
          this.carouselItems.forEach((element, i) => {
            const si = this.$refs[`ssitem${i}`][0];
            si.$on('ssimageloaded', this.onSlideshowImageLoaded);
            si.$on('ssimageloadError', this.onSlideshowImageLoaded);
          });
        }
        else if (this.allImagesLoaded && this.imageErrors === 0) {
          this.imageLoadigPhaseComplete();
        }
      });
    },

    // ---- On slideshow Image Loaded or Error ----//
    onSlideshowImageLoaded(e, status) {
      status === 'error' ? this.imageErrors++ : null;

      // this.tracetext += `image loaded staus = ${status} <br>`;
      // this.tracetext += `e.target = ${e.target.src} <br>`;
      // console.log('e',e)
      // console.log('e.target',e.target)

      this.loadedImages.add(e.target);

      this.loadingText = `Loading Image ${this.loadedImages.size}`;

      if (this.loadedImages.size === this.slideshowItems.length && !this.allImagesLoaded) {
        // console.log('-------------ALL images finished trying to load-----------');
        // this.tracetext += `LOADED IMAGES SIZE ${this.loadedImages.size} <br>`;
        this.carouselItems.forEach((element, i) => {
          const si = this.$refs[`ssitem${i}`][0];
          si.$off('ssimageloaded', this.onSlideshowImageLoaded);
          si.$off('ssimageloadError', this.onSlideshowImageLoaded);
        });

        this.allImagesLoaded = true;
        this.$nextTick(() => { this.checkImagesLoaded(); });
      }
    },

    checkImagesLoaded() {
      this.loadedImages.forEach((element, i) => {
        const status = element.dataset.status;

        // this.tracetext += `element.dataset.status = ${element.dataset.status} <br>`;

        if (status === 'error') {
          console.error('SLIDESHOW THUMBNAIL LOAD ERROR FOR URL: ', element.src);
          console.error('SLIDESHOW THUMBNAIL LOAD ERROR FOR URL: ', element);

          this.$nextTick(() => {
            this.removeSlideshowItem(element);
          });
        }
      });

      this.imageErrors === 0 ? this.imageLoadigPhaseComplete() : null;
    },

    removeSlideshowItem(target) {
      // console.log('removeSlideshowItem this.imageErrors =', this.imageErrors)
      // BECAUSE THE IMAGE URLS HAVE SPACES IN THEM - which is just TERRIBLE arrraggahah -
      // we need to check it against dataset.src instead as that URL has not been modified yet and contains the spaces present in the url array
      // once the src is set - spaces are automatically replaced with %20 etc so will be very hard to check against that

      const currentSrc = target.dataset.thumb;
      let posToRemove = -1;

      this.originalItems.forEach((element, i) => {
        if (element.imgURL == currentSrc || element.thumbURL == currentSrc) {
          posToRemove = i;
        }
      });

      if (posToRemove !== -1) {
        this.originalItems.splice(posToRemove, 1);
        this.imageErrors--;
      }

      this.initSlideshowData();
    },

    async imageLoadigPhaseComplete() {
      const imagedata = await this.storeImageData();
      this.imagesReady();
    },

    imagesReady() {
      if (!this.appInitialised) {
        this.appInitialised = true;
        this.initSlideshow();
      }
    },

    // -------------- Store Image Data ---------------//
    storeImageData() {
      return new Promise((resolve) => {
        const onIntersection = (entries) => {
          for (const entry of entries) {
            if (entry != undefined) {
              entry.target.dataset.io = entry;
              entry.target.dataset.nw = entry.target.naturalWidth;
              entry.target.dataset.nh = entry.target.naturalHeight;
              obv.unobserve(entry.target);
            }
          }

          resolve('DATA-COMPLETE');
        };

        const obv = new IntersectionObserver(onIntersection);
        this.carouselItems.forEach((element, i) => {
          const imgElement = element.firstElementChild.firstElementChild.firstElementChild;
          obv.observe(imgElement);
        });
      });
    },

    // ---------- OBSERVE SLIDESHOW IMAGES ---------//
    observeSlideshowImages() {
      const rootEl = this.$refs.mainContainer;
      const area = `0px ${this.ssImgWidth} ${this.ssImgHeight} 0px`;
      const config = {
        root: rootEl,
        rootMargin: '0px',
        // rootMargin: area,
        threshold: 0,
        // threshold: [...Array(100).keys()].map(x => x / 100)
      };

      this.imagesObserver = new IntersectionObserver(this.onObserveImage, config);

      this.carouselItems.forEach((element, i) => {
        const imgElement = element.firstElementChild.firstElementChild.firstElementChild;
        this.imagesObserver.observe(imgElement);
      });
    },

    onObserveImage(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (this.appInitialised) {
            // console.log('>>>image entry isIntersecting = ', entry.target.id, "target = ", entry.target);
            // console.log("-----at ratio = ", entry.intersectionRatio);
            const lazyImage = entry.target;
            const si = this.$refs[`ssitem${entry.target.id}`][0];
            si.$on('ssimageloadError', this.slideshowImageError);
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.add('loaded');
            this.imagesObserver.unobserve(lazyImage);
          }
        }
      }
    },

    // when thumbnail has loaded, but when we try to load the main image and get an error then reload thumbnail
    slideshowImageError(e, status) {
      console.warn('SLIDESHOW MAIN IMAGE LOAD ERROR FOR URL: ', e.target.src);
      const si = this.$refs[`ssitem${e.target.id}`][0];
      si.$off('ssimageloadError', this.slideshowImageError);
      const lazyImage = e.target;
      lazyImage.src = lazyImage.dataset.thumb;
    },

    // ---------------------- INITIALISE SLIDESHOW -------------------//
    initSlideshow() {
      this.configureItemStyles();
      this.setupSlideshow();
      this.populateSlideshowThumbnails();
      this.observeSlideshowImages();
      this.addListeners();
      this.onScreenResize();

      this.showSlideshowControls ? TweenMax.set(this.$refs.thumbsContainer, { css: { opacity: 0, top: this.ssdivHeight } }) : null;
    },

    configureItemStyles() {
      Bus.$emit('slideshowConfigureItemStyles', { width: this.ssImgWidth, height: this.ssImgHeight });
      this.carouselItems.forEach((element, i) => {
        const imgElement = element.firstElementChild.firstElementChild.firstElementChild;
        const imgHolder = element.firstElementChild.firstElementChild;
        const nw = parseInt(imgElement.dataset.nw);
        const nh = parseInt(imgElement.dataset.nh);

        element.style.width = this.ssImgWidth;
        element.style.height = this.ssImgHeight;

        imgHolder.style.width = this.ssImgWidth;
        imgHolder.style.height = this.ssImgHeight;

        if (nh > nw) {
          const newW = Math.round(parseInt(this.ssImgHeight) * (1280 / 1920));
          imgElement.style.height = this.ssImgHeight;
          imgElement.style.width = this.convertNumberToPixel(newW);
          imgElement.style.maxHeight = this.ssImgHeight;
        }
        else if (nw > nh) {
          imgElement.style.width = this.ssImgWidth;
          imgElement.style.height = this.ssImgHeight;
        }
      });
    },

    setupSlideshow() {
      this.itemWidth = parseInt(this.ssImgWidth);

      this.positions = this.getPositionsArray(0, this.itemWidth, this.numberOfItems + 2);

      this.repeatEndPosition = this.positions[this.numberOfItems - 1];
      this.repeatStartPosition = this.positions[1];

      if (this.imageIndex > 0) {
        this.posIndex = this.imageIndex;
      }

      const lastPos = this.positions[this.posIndex];

      let offPosition = parseInt(this.ssdivHeight) + 100;
      if (this.fullscreenFake || this.fullscreen) {
        offPosition = this.viewheight + 100;
      }

      this.showSlideshowControls ? TweenMax.set(this.$refs.thumbsContainer, { css: { opacity: 0, top: offPosition } }) : null;

      TweenMax.set(this.$refs.slideshowItemsHolder, { css: { left: lastPos } });
      TweenMax.to(this.$refs.tttSlideshow, 1, { alpha: 1, delay: 0.3 });
      TweenMax.delayedCall(0.6, this.slideshowReady);
    },

    slideshowReady() {
      this.$emit('initialised');
    },

    navButtonClicked(direction) {
      this.stopSlideshow();
      this.slideCarousel(direction);
    },

    slideCarousel(direction) {
      if (direction === CAROUSEL_DIRECTION.LEFT) {
        this.posIndex++;

        const next_positon = this.convertNumberToPixel(this.positions[this.posIndex]);

        if (this.$refs.slideshowItemsHolder) {
          TweenMax.to(this.$refs.slideshowItemsHolder, this.tweenTime, { css: { left: next_positon }, onComplete: this.checkCarouselItems, ease: this.easing });
        }
      }
      else if (direction === CAROUSEL_DIRECTION.RIGHT) {
        this.posIndex > 0 ? this.posIndex-- : this.posIndex = this.numberOfItems;

        const next_positon = this.convertNumberToPixel(this.positions[this.posIndex]);

        if (this.$refs.slideshowItemsHolder) {
          TweenMax.to(this.$refs.slideshowItemsHolder, this.tweenTime, { css: { left: next_positon }, onComplete: this.checkCarouselItems, ease: this.easing });
        }
      }

      if (this.posIndex >= this.numberOfItems + 1) {
        this.visibleIndex = 1;
      }
      else if (this.posIndex <= 0) {
        this.visibleIndex = this.numberOfItems;
      }
      else {
        this.visibleIndex = this.posIndex;
      }

      this.resetSlideContent();
    },

    checkCarouselItems() {
      if (this.posIndex >= this.numberOfItems + 1) {
        this.posIndex = 1;
        const pos = this.positions[this.posIndex];
        TweenMax.set(this.$refs.slideshowItemsHolder, { css: { left: pos } });
      }
      else if (this.posIndex <= 0) {
        this.posIndex = this.numberOfItems;
        const pos = this.positions[this.posIndex];
        TweenMax.set(this.$refs.slideshowItemsHolder, { css: { left: pos } });
      }

      this.resetSlideContent();

      this.onSlideComplete();
    },

    onSlideComplete() {
      this.getComponentInView.startContentAnimation();
    },

    resetSlideContent() {
      this.getComponentInView.resetContentAnimation();
    },

    // ----------------------------------- UTILS / HELPER METHODS ------------------------------------//

    getRealId(pos) {
      let realid = Math.abs(this.numberOfItems - pos);
      const r = Math.floor(realid / this.numberOfItems);
      realid = pos > this.numberOfItems ? realid - (r * this.numberOfItems) : pos;
      realid = realid <= 0 ? this.numberOfItems : realid;
      return realid;
    },

    showAllItems() {
      this.carouselItems.forEach((element) => {
        TweenMax.to(element, 0.2, { alpha: 1 });
      });
    },

    getNavStyles(direction) {
      return {
        left: direction === 'left' ? this.navIconPosition : null,
        right: direction === 'right' ? this.navIconPosition : null,
        width: this.navIconSize,
        height: this.navIconSize,
      };
    },

    // getComponentinView() {
    //   return this.$refs[`ssitem${this.posIndex}`][0];
    // },
    getIteminView() {
      return this.carouselItems[this.posIndex];
    },
    getElementinView() {
      return this.slideshowItems[this.posIndex];
    },
    getPositionsArray(start, increment, length) {
      return Array(length).fill(start).map((pos, i) => pos - (i * increment));
    },
    convertNumberToPixel(val) {
      return `${val}px`;
    },

    // ---------------------- ELEMENTS DATA -------------------//
    getElementBB(element, io = false) {
      return new Promise((resolve) => {
        const onIntersection = (entries) => {
          for (const entry of entries) {
            if (entry != undefined) {
              obv.unobserve(element);
              io ? resolve(entry) : resolve(entry.boundingClientRect);
            }
          }
        };

        const obv = new IntersectionObserver(onIntersection);
        element ? obv.observe(element) : null;
      });
    },

    // ----------------------------------- SLIDESHOW METHODS ------------------------------------//
    toggleSlideshow() {
      if (this.slideshowPlaying) {
        this.stopSlideshow();
      }
      else {
        this.showThumbnails ? this.toggleThumbnails() : null;
        this.slideshowPlaying = true;
        this.playSlideshow();
      }
    },

    playSlideshow() {
      if (this.slideshowPlaying)
      {
        TweenMax.killTweensOf(this.playNextSlide);
        TweenMax.delayedCall(this.autoPlayDelayTime, this.playNextSlide);
      }
    },

    playNextSlide() {
      if (this.slideshowPlaying) {
        this.slideCarousel(CAROUSEL_DIRECTION.LEFT);
        this.playSlideshow();
      }
    },

    stopSlideshow() {
      this.slideshowPlaying = false;
      TweenMax.killTweensOf(this.playNextSlide);
    },

    async mouseIsMoving(event) {
      const mousex = event.clientX;
      const mousey = event.clientY;

      if (this.$refs.mainContainer != null && !this.hideNavigation) {
        const mcp = await this.getElementBB(this.$refs.mainContainer);

        if (mousex < mcp.left || mousex > mcp.right || mousey < mcp.top || mousey > mcp.bottom) {
          this.interaction = false;
          TweenMax.delayedCall(0.5, this.fadeOutNav);
        }
        else {
          this.interaction = true;
        }
      }

      if (this.toggleNavVisibility && this.interaction && !this.hideNavigation) {
        TweenMax.killTweensOf(this.fadeOutNav);
        TweenMax.killTweensOf(this.$refs.leftBtn);
        TweenMax.killTweensOf(this.$refs.rightBtn);
        TweenMax.to(this.$refs.leftBtn, 0.3, { css: { left: this.navIconPosition, opacity: 1 } });
        TweenMax.to(this.$refs.rightBtn, 0.3, { css: { right: this.navIconPosition, opacity: 1 } });
      }
    },

    noIteraction() {
      this.interaction = false;
    },

    fadeOutNav() {
      if (this.toggleNavVisibility && !this.interaction && !this.hideNavigation) {
        if (this.$refs.leftBtn != null && this.$refs.rightBtn != null) {
          TweenMax.to(this.$refs.leftBtn, 0.3, { css: { left: '0px', opacity: 0 } });
          TweenMax.to(this.$refs.rightBtn, 0.3, { css: { right: '0px', opacity: 0 } });
        }
      }
    },

    // ------------------------ SIDESHOW THUMBNAILS ----------------------- //

    populateSlideshowThumbnails() {
      this.slideshowImages = this.originalItems.map((element, i) => {
        const {
          imgURL, thumbURL, title, image,
        } = element;
        return {
          imgURL, thumbURL, title, image, id: i + 1,
        };
      });

      TweenMax.delayedCall(1, this.layoutThumbnails);
    },

    layoutThumbnails() {
      const tm = this.$refs.thumbsMask ? this.$refs.thumbsMask.getBoundingClientRect() : { width: 0 };

      if (tm.width > 0) {
        let xnum = Math.floor((parseInt(tm.width) - 40) / (parseInt(this.ssThumbWidth)));
        let ynum = Math.floor((parseInt(tm.height) - 80) / (parseInt(this.ssThumbHeight)));
        xnum = xnum < 1 ? 1 : xnum;
        ynum = ynum < 1 ? 1 : ynum;
        const itemsPerPage = xnum * ynum;
        const pagesNeeded = Math.ceil(this.numberOfItems / itemsPerPage);

        this.thumbnailPages = [];

        this.thumbsXnum = xnum;
        this.thumbsYnum = ynum;

        for (let i = 0; i < pagesNeeded; i++) {
          const start = i * itemsPerPage;
          const end = start + itemsPerPage;
          const items = this.slideshowImages.slice(start, end);
          Vue.set(this.thumbnailPages, i, { id: i, items });
        }

        this.thumbPagesWidth = this.thumbnailPages.length * (parseInt(this.ssImgWidth));

        this.configureThumbnails();
      }
    },

    configureThumbnails() {
      const thumbs = Array.from(document.getElementsByClassName('thumb-img-holder'));

      thumbs.forEach((th, i) => {
        const thumbImage = th;
        const imgElement = th.firstElementChild;
        const nw = parseInt(imgElement.naturalWidth);
        const nh = parseInt(imgElement.naturalHeight);

        if (nh > nw) {
          const newW = Math.round(parseInt(this.ssThumbHeight) * (1280 / 1920));
          imgElement.style.height = this.ssThumbHeight;
          imgElement.style.width = this.convertNumberToPixel(newW);
          imgElement.style.maxHeight = this.ssThumbHeight;
        }
        else if (nw > nh) {
          imgElement.style.width = this.ssThumbWidth;
          imgElement.style.height = this.ssThumbHeight;
        }

        thumbImage.style.width = this.ssThumbWidth;
        thumbImage.style.height = this.ssThumbHeight;
      });
    },

    toggleThumbnails() {
      this.showThumbnails ? this.closeThumbnails() : this.openThumbnails();
    },

    openThumbnails() {
      this.configureThumbnails();
      let offPosition = parseInt(this.ssdivHeight) + 100;
      if (this.fullscreenFake || this.fullscreen) {
        offPosition = this.viewheight + 100;
      }
      this.showThumbnails = true;
      this.hideNavigation = true;
      this.slideshowPlaying ? this.toggleSlideshow() : null;
      TweenMax.set(this.$refs.thumbsContainer, { css: { top: offPosition, opacity: 1 } });
      TweenMax.to(this.$refs.thumbsContainer, this.thumbsTweenTime, { css: { top: 0 }, delay: 0.2, onComplete: this.thumbsOpenComplete });
    },

    closeThumbnails() {
      let offPosition = parseInt(this.ssdivHeight) + 100;
      if (this.fullscreenFake || this.fullscreen) {
        offPosition = this.viewheight + 100;
      }
      this.hideNavigation = this.hideNav;
      this.showThumbnailsDotsMenu = false;
      TweenMax.to(this.$refs.thumbsContainer, this.thumbsTweenTime, { css: { top: offPosition }, onComplete: this.thumbsCloseComplete });
    },

    thumbsOpenComplete() {
      this.showThumbnailsDotsMenu = true;
    },

    thumbsCloseComplete() {
      this.showThumbnails = false;
      TweenMax.set(this.$refs.thumbsContainer, { css: { opacity: 0 } });
    },

    slideToThumbnailPage(pageID = 0) {
      this.thumbnailPageID = pageID;
      const pos = this.convertNumberToPixel(-(parseInt(this.ssImgWidth)) * pageID);
      if (this.$refs.thumbsContainer) {
        TweenMax.to(this.$refs.thumbsContainer, this.thumbsTweenTime, { css: { left: pos }, delay: 0.1 });
      }
    },

    getNextThumbnailPage() {
      this.thumbnailPageID++;
      if (this.thumbnailPageID >= this.thumbnailPages.length) {
        this.thumbnailPageID = 0;
      }
      this.slideToThumbnailPage(this.thumbnailPageID);
      this.$refs.dots.selectID(this.thumbnailPageID);
    },

    getPreviousThumbnailPage() {
      this.thumbnailPageID--;
      if (this.thumbnailPageID < 0) {
        this.thumbnailPageID = this.thumbnailPages.length - 1;
      }
      this.slideToThumbnailPage(this.thumbnailPageID);
      this.$refs.dots.selectID(this.thumbnailPageID);
    },

    thumbnailClicked(e) {
      this.toggleThumbnails();
      this.slideTo(e, 0, 0);
    },

    slideTo(positionIndex, dtime = 0, speed = this.tweenTime) {
      this.posIndex = positionIndex;
      this.resetSlideContent();
      const next_positon = this.convertNumberToPixel(this.positions[this.posIndex]);
      TweenMax.to(this.$refs.slideshowItemsHolder, speed, {
        css: { left: next_positon }, delay: dtime, ease: this.easing, onComplete: this.onSlideComplete,
      });
    },

    navDotClicked(id) {
      this.slideTo(id + 1, 0, this.tweenTime);
    },

    // ------------------------- RESIZE METHODS -----------------------//
    debounceScreenResize() {
      window.clearTimeout(this.onResizeDebouncedTimeout);
      window.clearTimeout(this.onResetDebouncedTimeout);

      if (!this.resizeDone) {
        this.onResizeDebouncedTimeout = setTimeout(this.onScreenResize, 500);
        this.onResetDebouncedTimeout = setTimeout(this.resetScreenResize, 600);
        this.resizeDone = true;
      }
    },
    resetScreenResize() {
      this.resizeDone = false;
    },
    onScreenResize() {
      if (!this.resizeDone) {
        this.debounceScreenResize();
      }

      this.topMargin = 0;
      this.topPosition = '0px';
      this.leftPosition = '0px';

      const screenWidth = this.viewWidth = document.documentElement.clientWidth;
      let screenHeight = this.viewheight = window.innerHeight;// document.documentElement.clientHeight;
      const parentWidth = this.$vnode.elm.parentNode?.getBoundingClientRect().width;
      // console.log('this.$vnode.elm.parentNode', this.$vnode.elm.parentNode.getBoundingClientRect())
      const container_width = parseInt(this.slideshowImageWidth);

      const naturalWidth = parseInt(this.carouselItems[1].firstElementChild.firstElementChild.firstElementChild.dataset.nw);
      const naturalHeight = parseInt(this.carouselItems[1].firstElementChild.firstElementChild.firstElementChild.dataset.nh);

      const aspectRatio = (naturalWidth / naturalHeight) - 0.1;
      const currentRatio = screenWidth / screenHeight;

      this.tweenTime = screenWidth < 500 ? 0.5 : 1;

      // const innerWidth = window.innerWidth;
      // const innerHeight = window.innerHeight;

      // console.log('---------------this.fullscreen= ', this.fullscreen);
      // console.log('---------------this.fullscreenFake= ', this.fullscreenFake);
      // console.log('screenWidth= ', screenWidth);
      // console.log('document width = ', screenWidth);
      // console.log('document height', screenHeight);
      // console.log('innerWidth', innerWidth);
      // console.log('innerHeight', innerHeight);
      // console.log('naturalWidth', naturalWidth);
      // console.log('naturalHeight', naturalHeight);
      // console.log('( naturalWidth / naturalHeight) ',( naturalWidth / naturalHeight) )
      // console.log('( screenWidth / screenHeight) ',( screenWidth / screenHeight) )

      // this.tracetext += `screen width = ${document.documentElement.clientWidth}  :`;
      // this.tracetext += `screen height = ${screenHeight}  `;

      if (parentWidth < container_width && !this.fullscreen && !this.fullscreenFake) {
        // console.log('-------slideshow resize condition 1 - not full screen ----------')

        const calulatedWidth = parentWidth;
        let calulatedHeight = Math.round(calulatedWidth * (naturalHeight / naturalWidth));

        if (this.containHeight) {
          calulatedHeight = parseInt(this.slideshowImageHeight);
        }

        this.ssImgWidth = this.convertNumberToPixel(calulatedWidth);
        this.ssImgHeight = this.convertNumberToPixel(calulatedHeight);

        const cth = Math.round((calulatedWidth / 6) * (1280 / 1920));

        this.ssThumbWidth = this.convertNumberToPixel(Math.round(calulatedWidth / 6));
        this.ssThumbHeight = this.convertNumberToPixel(cth);

        this.configureItemStyles();
        this.setupSlideshow();
        this.layoutThumbnails();
        this.slideToThumbnailPage(this.thumbnailPageID);
      }
      else if (!this.fullscreen && !this.fullscreenFake) {
        this.ssImgWidth = this.slideshowImageWidth;
        this.ssImgHeight = this.slideshowImageHeight;
        this.ssThumbWidth = this.slideshowThumbWidth;
        this.ssThumbHeight = this.slideshowThumbHeight;

        this.configureItemStyles();
        this.setupSlideshow();
        this.layoutThumbnails();
        this.slideToThumbnailPage(this.thumbnailPageID);
      }

      if (this.fullscreenFake || this.fullscreen) {
        if (currentRatio >= aspectRatio) {
          // remove 50px to allow space for the control bar if needed
          screenHeight -= 50;

          // const calulatedHeight = Math.round(screenWidth * (naturalHeight / naturalWidth) );
          const calulatedWidth = Math.round(screenHeight * (naturalWidth / naturalHeight));

          this.ssImgWidth = this.convertNumberToPixel(calulatedWidth);
          this.ssImgHeight = this.convertNumberToPixel(screenHeight);

          const cth = Math.round((calulatedWidth / 6) * (1280 / 1920));
          this.ssThumbWidth = this.convertNumberToPixel(Math.round(calulatedWidth / 6));
          this.ssThumbHeight = this.convertNumberToPixel(cth);

          if (this.fullscreenFake) {
            this.topPosition = '0px';
            this.leftPosition = this.convertNumberToPixel(Math.round((screenWidth - calulatedWidth) / 2));
          }
        }
        else if (currentRatio < aspectRatio) {
          const calulatedHeight = Math.round(screenWidth * (naturalHeight / naturalWidth));

          this.ssImgWidth = this.convertNumberToPixel(screenWidth);
          this.ssImgHeight = this.convertNumberToPixel(calulatedHeight);

          const cth = Math.round((screenWidth / 6) * (1280 / 1920));
          this.ssThumbWidth = this.convertNumberToPixel(Math.round(screenWidth / 6));
          this.ssThumbHeight = this.convertNumberToPixel(cth);

          this.topPosition = this.convertNumberToPixel(Math.round((screenHeight - 50 - calulatedHeight) / 2));
          this.leftPosition = '0px';
        }

        this.configureItemStyles();
        this.setupSlideshow();
        this.layoutThumbnails();
        this.slideToThumbnailPage(this.thumbnailPageID);
      }
    },

    // ------------------------------ FULL SCREEN METHODS -----------------------//
    overlayClicked() {
      this.$emit('overlayClicked');
    },

    openImagePopup() {
      const imgElement = this.getIteminView().firstElementChild.firstElementChild.firstElementChild;
      this.goFullScreen(imgElement);
      this.slideshowPlaying = false;
    },

    toggleFullScreen() {
      if (this.fullscreen || this.fullscreenFake) {
        this.exitFullscreen();
      }
      else {
        this.loadFullScreenSlideshow();
      }
    },

    loadFullScreenSlideshow() {
      const mainapp = this.$refs.mainContainer ? this.$refs.mainContainer.parentNode : this.$parent.$el;
      this.goFullScreen(mainapp);
    },

    fakeFullScreen() {
      this.$store.commit('common/setFakeFullScreen', true);
      this.$store.commit('common/setSlideshowFullScreen', true);
      this.fullscreenFake = true;
      this.$emit('onSlideshowFullScreen');
      Bus.$emit('slideshowFullScreen');
      this.onScreenResize();
    },

    goFullScreen(element) {
      if (element.requestFullscreen) {
        this.fullscreen = true;
        element.requestFullscreen();
      }
      else if (element.mozRequestFullScreen) {
        this.fullscreen = true;
        element.mozRequestFullScreen();
      }
      else if (element.webkitRequestFullscreen) {
        this.fullscreen = true;
        element.webkitRequestFullscreen();
      }
      else if (element.msRequestFullscreen) {
        this.fullscreen = true;
        element.msRequestFullscreen();
      }
      else {
        this.fakeFullScreen();
      }

      this.$store.commit('common/setSlideshowFullScreen', true);
    },

    exitFullscreen() {
      if (this.fullscreenFake) {
        this.$store.commit('common/setFakeFullScreen', false);
        this.$store.commit('common/setSlideshowFullScreen', false);
        this.fullscreen = false;
        this.fullscreenFake = false;
        this.onScreenResize();
        Bus.$emit('slideshowExitFullScreen');
        this.$emit('onSlideshowExitFullScreen');
        return;
      }

      if (this.fullScreenAvailable) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
        else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        }
        else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
        else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }

        this.$store.commit('common/setSlideshowFullScreen', false);
      }
    },

    onFullScreenChange() {
      // console.log('onFullScreenChange document.fullscreenElement', document.fullscreenElement)
      // console.log('onFullScreenChange document.webkitFullscreenElement', document.webkitFullscreenElement)
      // console.log('onFullScreenChange document.mozFullScreenElementement', document.mozFullScreenElementement)
      // console.log('onFullScreenChange document.msFullscreenElement', document.msFullscreenElement)

      const mainapp = this.$refs.mainContainer?.parentNode || this.$refs.mainContainer || null;

      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        this.fullscreen = true;
        this.$store.commit('common/setSlideshowFullScreen', true);
        mainapp ? mainapp.style.backgroundColor = '#000000' : null;
        this.$emit('onSlideshowFullScreen');
        Bus.$emit('slideshowFullScreen');
        this.$nextTick(() => {
          this.$refs.tttSlideshow?.focus();
        });
      }
      else {
        this.fullscreen = false;
        mainapp ? mainapp.style.backgroundColor = 'transparent' : null;
        this.$store.commit('common/setSlideshowFullScreen', false);
        this.$emit('onSlideshowExitFullScreen');
        Bus.$emit('slideshowExitFullScreen');
      }

      this.onScreenResize();
    },

    // ------------------- SWIPE AND KEYBOARD NAVIGATION -------------- //
    swipeHandler(direction) {
      if (this.showThumbnails) {
        direction === 'left' ? this.getNextThumbnailPage() : null;
        direction === 'right' ? this.getPreviousThumbnailPage() : null;
      }
      else {
        direction === 'left' ? this.slideCarousel(CAROUSEL_DIRECTION.LEFT) : null;
        direction === 'right' ? this.slideCarousel(CAROUSEL_DIRECTION.RIGHT) : null;
      }
    },

    keyboardPressed(e) {
      switch (e.key) {
        case 'ArrowLeft':
          this.slideCarousel(CAROUSEL_DIRECTION.RIGHT);
          break;
        case 'ArrowRight':
          this.slideCarousel(CAROUSEL_DIRECTION.LEFT);
          break;
        case 'Escape':
          this.fullscreenFake || this.fullscreen ? this.exitFullscreen() : null;
          break;
        default:
        // console.log('keyboard pressed ', e.key);
      }
    },

    // ----------------------------------- EVENTS ------------------------------------//
    addListeners() {
      this.resizeDone = false;
      window.addEventListener('resize', this.onScreenResize);
      document.addEventListener('fullscreenchange', this.onFullScreenChange, false);
      document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
      document.addEventListener('MSFullscreenChange', this.onFullScreenChange, false);
      document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
      this.toggleNavVisibility && !this.hideNavigation ? window.addEventListener('mousemove', this.mouseIsMoving) : null;
    },

    removeListeners() {
      window.removeEventListener('resize', this.onScreenResize);
      document.removeEventListener('fullscreenchange', this.onFullScreenChange, false);
      document.removeEventListener('mozfullscreenchange', this.onFullScreenChange, false);
      document.removeEventListener('MSFullscreenChange', this.onFullScreenChange, false);
      document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
      this.toggleNavVisibility && !this.hideNavigation ? window.removeEventListener('mousemove', this.mouseIsMoving) : null;
    },

    userRightClick() {
      // To Do : maybe add a pop up to tell users no right click is allowed
      // alert("SORRY NO RIGHT CLICK IS ALLOWED ON THE GALLERY");
    },

    setupConsole() {
      // console.defaultLog = console.log.bind(console);
      // console.logs = [];
      // console.log = function(){
      //     // default &  console.log()

      //     console.defaultLog.apply(console, arguments);
      //     // new & array data
      //     console.logs.push(Array.from(arguments));
      //     //tracetext = 'logs ='+console.logs.toString();

      // }

      // // //this.tracetext += console.logs;

      // // //console.log('LOGS==', console.logs.toString())

      //     this.tracetext = 'setupConsole logged'

      // console.log = function(e){
      //     alert("this", e);

      // }

    },

  },

};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";

.slideshow-container{
    position: relative;
    margin:  0 auto;
    max-width: 1920px;
}

.ttt-slideshow,
.ttt-slideshow:focus{
    outline: 0;
}

.slideshow-mask{
    background-color:transparent;
    overflow: hidden;
}

.slideshow-contents{
    position: relative;
    display: flex;
    background-color: $black;
}

.carousel-nav{
    z-index: 3;

    @include mobile-down {
      z-index:5;
    }
}

.btn-right{
    transform: rotate(180deg);
}

.left-button {
    position: absolute;
    top: 47%;
    z-index: 3;
    left: -60px;
    cursor: pointer;
    @include mobile-down {
      z-index: 5;
      top: 74%;
    }
}

.right-button {
    position: absolute;
    top: 47%;
    z-index: 3;
    right: -60px;
    cursor: pointer;
    @include mobile-down {
      z-index: 5;
      top: 74%;
    }
}

.slideshow-controls{
    background-color: $black;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: nowrap;
    font-family: $font-family-grotesk;
    font-size: 15px;
    line-height: 1.1;
    color: $stoneWhite;

    @media (max-width: 700px) {
        font-size: 14px;
    }

    @media (max-width: 500px) {
        font-size: 13px;
    }

    @media (max-width: 410px) {
        font-size: 11px;
    }
}

.controls-btn{
    cursor: pointer;
}

.ss-title{
    width: 50% !important;
}

.ss-controls-img{
    fill: $stoneWhite;
    margin: 3px 0 0 0;
    width: 18px;
    height: 18px;
}

.playpause{
    width: 22px;
    height: 22px;
}

// -- SLIDESHOW THUMBNAILS -- //
.thumbs-mask{
    position: absolute;
    top:0;
    left: 0;
    height: 100%;
    background-color:transparent;
    overflow: hidden;
}

.slideshow-thumbnails-container{
    position: absolute;
    top:0;
    left: 0;
    background-color: rgba($white, .8);
    display:flex;
    flex-direction: row;
    justify-content:flex-start;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: nowrap;
    opacity: 0;
}

.slideshow-thumbnails-page{
    position: relative;
    top:0;
    padding: 30px 30px 30px 30px;
    display: grid;
    grid-template-columns: repeat(5, auto);
    grid-template-rows: repeat(4, auto);
    column-gap: 5px;
    row-gap: 5px;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    @media (max-width: 500px) {
       padding: 30px 20px 30px 20px;
    }
    @media (max-width: 380px) {
       padding: 35px 10px 30px 10px;
    }
}

.thumb-img-holder{
    display:flex;
    align-items: center;
    align-content: center;
    border: 5px solid whitesmoke;
    border-radius: 0px;
    overflow:hidden;
    background-color: rgba(7, 4, 4, 0.5);
    cursor: pointer;
}

.thumb-img-holder:hover{
    border: 5px solid rgba(0, 0, 0,0.8);
}

.thumb-img{
    border-radius: 0px;
    margin: 0 auto;
    width:100%;
    height: auto;
}

.slideshow-thumbnails{
    position: absolute;
    top:0;
    left: 0;
    background-color: rgba($white, .8);
    padding: 10px;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    height: 100%;
}

//------NAVIGATION DOTS MENU-------//
.dots-nav{
    //position: absolute;
    padding: 10px 0 10px 0;
    margin: 0 auto;
    background-color: $stoneWhite;
}

//------THUMBNAILS DOTS MENU-------//
.dots-menu{
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 10px;
}

// Overlay buttons
.slideshow-close{
    z-index: 100;
    position: absolute;
    top:10px;
    right: 10px;
    cursor: pointer;
}

.slideshow-close-img{
    width: 20px;
    height: auto;
}

.slideshow-full-screen-btn{
  z-index: 100;
  position: absolute;
  top:20px;
  right: 20px;
  cursor: pointer;
}

.slideshow-count-overlay{
  z-index: 100;
  position: absolute;
  bottom:20px;
  left: 20px;
  padding: 1px 10px;
  border-radius: 5px;
  background-color: rgba(87, 87, 87, 0.7);
  font-family: $font-family-grotesk;
  font-size: 14px;
  font-style: italic;
  color: #ffffff;
}

//Loading
.loading-text{
    position: absolute;
    top: 48%;
    left:0px;
    display: flex;
    align-content: center;
    justify-content: center;
    z-index: 100;
    width: 100%;
}

//-----for testing
// .tracetxt{
//     z-index: 100;
//     position: absolute;
//     top:10px;
//     left: 10px;
//     cursor: pointer;
//     color: $stoneWhite;
//     max-width: 850px;
//     font-size: 14px;
//     background-color: $black;
//     padding: 5px;
//     max-height: 600px;
//     overflow-y:scroll;

//     @include mobile-down{
//         max-width: 400px;
//         width: 80%;
//     }
// }

</style>
